'use client';

import { DialogContent } from '@mui/material';

import { styled } from '../../styles';

import { DialogContentProps } from './types';

export const StyledDialogContent = styled(DialogContent)<DialogContentProps>(
  ({ theme, size }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowX: 'hidden',
    padding: size === 'small' ? theme.spacing(6, 4) : theme.spacing(10, 6),
  }),
);
